import cx from "classnames";
import { useCallback, useMemo } from "react";
import { compact } from "lodash";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import feed from "modules/cycles/state/feed";
import CycleActivityCard from "../CycleActivityCard";
import FocusCycleButton from "../FocusCycleButton";
import { onSuccess } from "modules/Core/sub-modules/Dialog/state/cells";
import { ExpandableOptions } from "modules/Core/sub-modules/ui-kit/exports";
import CompleteCycleButton from "../CompleteCycleButton";
import AddCycleActivityButton from "../AddCycleActivityButton";

import styles from "./styles.module.scss";

const ItemComponent = ({ className, refetchFeed, displayFocus, onFocusCallback, isCompleted, isForthcoming, ...item }) => {
    const flow = compact(item?.flow);
    return (
        <Container className={cx(styles.container, className)} bg1 flex col>
            <Container>
                <Container maxWidth flex flexEnd>
                    <ExpandableOptions
                        tridot
                        options={compact([
                            { 
                                Component: FocusCycleButton, 
                                props: { cycleId: item.id, className: styles.focusButton, callback: onFocusCallback } 
                            },
                            !isCompleted && { 
                                Component: CompleteCycleButton, 
                                props: { cycleId: item.id, className: styles.completeButton, callback: refetchFeed } 
                            },
                            isForthcoming && {
                                Component: AddCycleActivityButton,
                                props: { cycleId: item.id, boothId: item.boothId, onSuccess: refetchFeed, text: "Add task" }
                            },
                            { 
                                text: "View Cycle", 
                                props: { to: `/cycles/${item.id}` } 
                            }
                        ])}
                        optionsOrigin="right"
                    />
                </Container>
            </Container>
            {flow.map((activity, index) => (
                <CycleActivityCard
                    key={activity.id}
                    feedItem
                    cycleId={item.id}
                    boothId={item.boothId}
                    activity={activity}
                    index={index}
                    flowLength={flow.length}
                    onRefetch={refetchFeed}
                />
            ))}
        </Container>
    )
}

export default strappedConnected(
    feed.FeedComponent,
    {},
    {
        refetchFeed: () => feed.cells.fetchFeed.action({ renewStream: true }),
        onSuccess
    },
    ({ boothId, isCompleted, isForthcoming, className, refetchFeed, displayFocus, onSuccess }) => {
        const onFocusCallback = useCallback(() => {
            onSuccess("Cylce focused");
            refetchFeed();
        }, [onSuccess, refetchFeed]);


        return ({
            filters: useMemo(() => ({
                boothId,
                isCompleted,
                isForthcoming
            }), [boothId, isCompleted, isForthcoming]),
            feedItemClassName: className,
            ItemComponent,
            itemProps: useMemo(() => ({ displayFocus, onFocusCallback, refetchFeed, isCompleted, isForthcoming }), [refetchFeed, displayFocus, onFocusCallback, isCompleted, isForthcoming])
        })
    }
)
